var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _g, _path89, _path90, _path91, _path92, _path93, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaptopIntegrationDt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 117,
    viewBox: "0 0 231 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4454_121031)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.945 112.616L114.944 112.309",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119 111.687L189.794 100.817",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.03 3.03"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M191.805 100.506L193.804 100.199",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.201 111.413C199.503 111.413 204.612 106.322 204.612 100.043C204.612 93.7644 199.503 88.6742 193.201 88.6742C186.898 88.6742 181.789 93.7644 181.789 100.043C181.789 106.322 186.898 111.413 193.201 111.413Z",
    fill: "white",
    stroke: "#F48000",
    strokeWidth: 1.748,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.294 103.55C200.294 103.856 200.044 104.105 199.737 104.105H186.987C186.679 104.105 186.43 103.856 186.43 103.55V95.7802C186.43 95.4738 186.679 95.2252 186.987 95.2252H199.737C200.044 95.2252 200.294 95.4738 200.294 95.7802V103.55Z",
    fill: "#FFD2A0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M200.294 95.7803C200.294 95.4926 200.073 95.2593 199.792 95.2311L193.238 100.247L186.748 95.2809C186.56 95.3701 186.43 95.5595 186.43 95.7806V95.9701L193.238 101.18L200.294 95.7803Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M205.037 65.3055L203.227 66.2039",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.56 68.0237L113.422 110.783",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3.03 3.03"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M111.591 111.693L109.781 112.591",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M218.024 78.2476C225.198 71.1002 225.198 59.5121 218.024 52.3647C210.85 45.2173 199.218 45.2173 192.044 52.3647C184.87 59.5121 184.87 71.1002 192.044 78.2476C199.218 85.395 210.85 85.395 218.024 78.2476Z",
    fill: "white",
    stroke: "#F48000",
    strokeWidth: 1.748,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M216.236 54.671H202.973C201.81 54.671 200.867 55.6017 200.867 56.7498V60.8678C200.867 62.0158 201.81 62.9466 202.973 62.9466H212.615L216.026 66.0649V62.9466H216.236C217.399 62.9466 218.341 62.0158 218.341 60.8678V56.7498C218.342 55.6017 217.399 54.671 216.236 54.671Z",
    fill: "#FAA64B",
    stroke: "#FAA64B",
    strokeWidth: 0.173068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M206.932 58.7882C206.932 59.2489 206.554 59.6222 206.087 59.6222C205.62 59.6222 205.242 59.2489 205.242 58.7882C205.242 58.3275 205.62 57.9542 206.087 57.9542C206.554 57.9539 206.932 58.3275 206.932 58.7882Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M210.432 58.7882C210.432 59.2489 210.054 59.6222 209.587 59.6222C209.12 59.6222 208.742 59.2489 208.742 58.7882C208.742 58.3275 209.12 57.9542 209.587 57.9542C210.054 57.9539 210.432 58.3275 210.432 58.7882Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M213.955 58.7882C213.955 59.2489 213.577 59.6222 213.11 59.6222C212.644 59.6222 212.266 59.2489 212.266 58.7882C212.266 58.3275 212.644 57.9542 213.11 57.9542C213.577 57.9542 213.955 58.3275 213.955 58.7882Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M213.051 69.8182H202.617C201.703 69.8182 200.961 70.5505 200.961 71.4534V74.6929C200.961 75.5962 201.703 76.3281 202.617 76.3281H210.202L212.885 78.7813V76.3281H213.051C213.966 76.3281 214.707 75.5958 214.707 74.6929V71.4534C214.707 70.5505 213.966 69.8182 213.051 69.8182Z",
    fill: "#FFA865",
    stroke: "#FFA865",
    strokeWidth: 0.136145,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M204.337 73.5539C204.804 73.5539 205.182 73.1805 205.182 72.72C205.182 72.2594 204.804 71.886 204.337 71.886C203.87 71.886 203.492 72.2594 203.492 72.72C203.492 73.1805 203.87 73.5539 204.337 73.5539Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.682 72.72C208.682 73.1806 208.304 73.5539 207.837 73.5539C207.37 73.5539 206.992 73.1803 206.992 72.72C206.992 72.2593 207.37 71.886 207.837 71.886C208.304 71.886 208.682 72.2593 208.682 72.72Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.36 73.5539C211.827 73.5539 212.205 73.1805 212.205 72.72C212.205 72.2594 211.827 71.886 211.36 71.886C210.894 71.886 210.516 72.2594 210.516 72.72C210.516 73.1805 210.894 73.5539 211.36 73.5539Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M193.027 60.6721H206.291C207.454 60.6721 208.396 61.6029 208.396 62.751V66.8689C208.396 68.017 207.454 68.9478 206.291 68.9478H196.648L193.238 72.066V68.9478H193.027C191.865 68.9478 190.922 68.017 190.922 66.8689V62.751C190.922 61.6029 191.864 60.6721 193.027 60.6721Z",
    fill: "#FFE4C6",
    stroke: "#FFE4C6",
    strokeWidth: 0.173068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M202.32 64.789C202.32 65.2497 202.698 65.623 203.165 65.623C203.632 65.623 204.01 65.2494 204.01 64.789C204.01 64.3284 203.632 63.9551 203.165 63.9551C202.698 63.9551 202.32 64.3284 202.32 64.789Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M198.805 64.789C198.805 65.2497 199.183 65.623 199.649 65.623C200.116 65.623 200.494 65.2494 200.494 64.789C200.494 64.3284 200.116 63.9551 199.649 63.9551C199.183 63.9551 198.805 64.3284 198.805 64.789Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.297 64.789C195.297 65.2497 195.675 65.623 196.142 65.623C196.608 65.623 196.986 65.2494 196.986 64.789C196.986 64.3284 196.608 63.9551 196.142 63.9551C195.675 63.9551 195.297 64.3284 195.297 64.789Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.242 112.03L110.431 110.4",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M112.773 107.19L167.79 31.7675",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.95 2.95"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.953 30.1629L170.142 28.5329",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M183.372 41.7129C190.678 34.4343 190.678 22.6334 183.372 15.3548C176.066 8.07624 164.221 8.07625 156.916 15.3548C149.61 22.6334 149.61 34.4343 156.916 41.7129C164.221 48.9915 176.066 48.9915 183.372 41.7129Z",
    fill: "white",
    stroke: "#F48000",
    strokeWidth: 1.748,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.212 19.4177H169.102V33.4386H180.212V19.4177Z",
    fill: "#FFA865"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M167.422 23.5831V33.914",
    stroke: "#1A1A1A",
    strokeWidth: 0.515242,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M171.172 23.5831V33.914",
    stroke: "#1A1A1A",
    strokeWidth: 0.515242,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M174.93 24.2288V33.914",
    stroke: "#1A1A1A",
    strokeWidth: 0.515242,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M178.695 24.7451V33.9139",
    stroke: "#1A1A1A",
    strokeWidth: 0.515242,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M165.016 27.1885H181.801",
    stroke: "#1A1A1A",
    strokeWidth: 0.515242,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M165.922 30.6107H181.8",
    stroke: "#1A1A1A",
    strokeWidth: 0.515242,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.742 20.1107H161.732L167.295 33.7381H181.901V24.9613L162.891 22.4204",
    stroke: "#1A1A1A",
    strokeWidth: 0.686989,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M167.224 33.9139L165.211 37.4337H179.816",
    stroke: "#1A1A1A",
    strokeWidth: 0.686989,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M161.131 19.4177H157.742C157.358 19.4177 157.047 19.728 157.047 20.1107C157.047 20.4934 157.358 20.8036 157.742 20.8036H161.131V19.4177Z",
    fill: "#F48000"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M165.398 39.144C165.398 39.893 166.008 40.4999 166.759 40.4999C167.511 40.4999 168.12 39.893 168.12 39.144C168.12 38.395 167.511 37.788 166.759 37.788C166.008 37.788 165.398 38.395 165.398 39.144Z",
    fill: "#F48000"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.77 39.7087C167.083 39.7087 167.337 39.4558 167.337 39.1439C167.337 38.832 167.083 38.5791 166.77 38.5791C166.457 38.5791 166.203 38.832 166.203 39.1439C166.203 39.4558 166.457 39.7087 166.77 39.7087Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M176.875 39.144C176.875 39.893 177.484 40.4999 178.236 40.4999C178.988 40.4999 179.597 39.893 179.597 39.144C179.597 38.395 178.988 37.788 178.236 37.788C177.484 37.788 176.875 38.395 176.875 39.144Z",
    fill: "#F48000"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M178.247 39.7087C178.56 39.7087 178.814 39.4558 178.814 39.1439C178.814 38.832 178.56 38.5791 178.247 38.5791C177.934 38.5791 177.68 38.832 177.68 39.1439C177.68 39.4558 177.934 39.7087 178.247 39.7087Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M120.341 39.4063L120.016 41.395",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M119.392 45.2559L109.617 105.101",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.91 2.91"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M109.301 107.031L108.977 109.02",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M132.621 43.87C136.288 37.3064 133.92 29.0243 127.331 25.3714C120.743 21.7186 112.43 24.0782 108.764 30.6418C105.097 37.2054 107.466 45.4875 114.054 49.1404C120.642 52.7932 128.955 50.4336 132.621 43.87Z",
    fill: "white",
    stroke: "#F48000",
    strokeWidth: 1.748,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.941 34.6871C126.941 31.2043 124.107 28.3806 120.611 28.3806C117.115 28.3806 114.281 31.2043 114.281 34.6871C114.281 37.2246 115.786 39.4103 117.954 40.4111V43.4851C117.954 44.9469 119.144 46.1322 120.611 46.1322C122.079 46.1322 123.268 44.9469 123.268 43.4851V40.4111C125.437 39.4103 126.941 37.2246 126.941 34.6871Z",
    fill: "#FFE4C6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M119.281 42.084V36.0111H121.938V42.084",
    stroke: "#F48000",
    strokeWidth: 0.173689,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M117.734 41.9283V44.4744C117.734 46.0351 119.005 47.3005 120.571 47.3005C122.138 47.3005 123.408 46.0351 123.408 44.4744V41.9283H117.734Z",
    fill: "#F48000"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M117.648 42.8625H123.588",
    stroke: "#F48000",
    strokeWidth: 0.521068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M117.648 44.1862H123.588",
    stroke: "#F48000",
    strokeWidth: 0.521068,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M105.265 108.055L104.258 106.307",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M102.267 102.885L59.8828 29.3049",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.93 2.93"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M58.905 27.5939L57.8984 25.8462",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9511 43.7891C72.8977 41.0047 78.6954 30.7142 75.9006 20.8045C73.1058 10.8949 62.7769 5.11879 52.8302 7.9032C42.8836 10.6876 37.0859 20.9782 39.8808 30.8878C42.6756 40.7974 53.0045 46.5735 62.9511 43.7891Z",
    fill: "white",
    stroke: "#F48000",
    strokeWidth: 1.748,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6703 12.535C50.3267 12.6444 44.4062 18.6055 44.4062 25.9479C44.4062 33.2903 50.3267 39.2518 57.6703 39.3608V12.535Z",
    fill: "#FFF1E1",
    stroke: "#FFF1E1",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6816 39.5288C57.5897 39.5274 57.5156 39.4526 57.5156 39.361V12.5352C57.5156 12.4433 57.5897 12.3685 57.6823 12.3674C57.6823 12.3674 57.8484 12.3622 57.8886 12.3622C65.408 12.3622 71.5252 18.4566 71.5252 25.9481C71.5252 33.4396 65.408 39.534 57.8886 39.534C57.8473 39.5337 57.6816 39.5288 57.6816 39.5288Z",
    fill: "#FFA865"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M57.877 12.5301C65.3153 12.5301 71.3452 18.5375 71.3452 25.9482C71.3452 33.3589 65.3153 39.3663 57.877 39.3663C57.8085 39.3663 57.741 39.3621 57.6729 39.3611V12.5353C57.741 12.5343 57.8085 12.5301 57.877 12.5301ZM57.877 12.1941C57.834 12.1941 57.7917 12.1955 57.7491 12.1969L57.668 12.1993C57.4838 12.2021 57.3359 12.3515 57.3359 12.535V39.3607C57.3359 39.5442 57.4838 39.694 57.668 39.6964L57.7491 39.6988C57.7914 39.7002 57.834 39.7016 57.8766 39.7016C65.4887 39.7016 71.6817 33.5316 71.6817 25.9479C71.6821 18.3641 65.4894 12.1941 57.877 12.1941Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6844 26.0324C57.6512 26.0324 57.6187 26.0226 57.5901 26.0035C57.5436 25.9721 57.5156 25.9199 57.5156 25.8642V12.3315C57.5156 12.2396 57.5897 12.1651 57.6816 12.1637C57.6816 12.1637 57.8473 12.1584 57.8882 12.1584C63.4839 12.1584 68.4502 15.502 70.5406 20.6768C70.5752 20.7628 70.5336 20.8603 70.4476 20.8951L57.7477 26.0198C57.7274 26.0282 57.7058 26.0324 57.6844 26.0324Z",
    fill: "#1A1A1A"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.877 12.3267C63.5388 12.3267 68.3813 15.8092 70.3728 20.74L57.6729 25.8646V12.332C57.741 12.3309 57.8085 12.3267 57.877 12.3267ZM57.877 11.9907C57.834 11.9907 57.7917 11.9921 57.7491 11.9935L57.668 11.9959C57.4838 11.9987 57.3359 12.1481 57.3359 12.3316V25.8643C57.3359 25.9761 57.3919 26.0802 57.4845 26.1428C57.5411 26.1808 57.6068 26.2003 57.6729 26.2003C57.7155 26.2003 57.7585 26.1923 57.7994 26.1759L70.4993 21.0513C70.6716 20.9816 70.7548 20.7863 70.6856 20.6146C68.5697 15.3757 63.5419 11.9907 57.877 11.9907Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6844 26.0324C57.6607 26.0324 57.6366 26.0272 57.6138 26.0171C57.5541 25.9896 57.5156 25.9304 57.5156 25.8645V12.5352C57.5156 12.4433 57.5897 12.3688 57.6816 12.3674C57.6816 12.3674 57.8473 12.3622 57.8882 12.3622C61.7972 12.3622 65.5251 14.0406 68.116 16.9673C68.1457 17.0011 68.1608 17.0453 68.1576 17.0902C68.1545 17.1352 68.1335 17.1766 68.0993 17.2062L57.7938 25.9927C57.7631 26.0184 57.7239 26.0324 57.6844 26.0324Z",
    fill: "#FFD2A0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M57.877 12.5301C61.9013 12.5301 65.5104 14.2907 67.9786 17.0781L57.6732 25.8646V12.5353C57.741 12.5339 57.8085 12.5301 57.877 12.5301ZM57.877 12.1941C57.834 12.1941 57.7917 12.1955 57.7491 12.1969L57.668 12.1993C57.4838 12.2021 57.3359 12.3515 57.3359 12.535V25.8643C57.3359 25.9952 57.4125 26.1147 57.532 26.1693C57.5771 26.1899 57.625 26.2 57.6729 26.2C57.7519 26.2 57.8298 26.1725 57.892 26.1192L68.1974 17.3327C68.2659 17.2742 68.3082 17.1906 68.3145 17.1011C68.3208 17.0116 68.2908 16.9228 68.231 16.8553C65.6086 13.8934 61.8345 12.1941 57.877 12.1941Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1172 15.1002L50.7911 24.839",
    stroke: "#1A1A1A",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4531 25.4269C50.4531 26.1222 51.019 26.6863 51.7173 26.6863C52.4153 26.6863 52.9815 26.1226 52.9815 25.4269C52.9815 24.7315 52.4156 24.1674 51.7173 24.1674C51.019 24.1674 50.4531 24.7315 50.4531 25.4269Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0772 15.6041C37.0772 16.1605 36.6246 16.6115 36.066 16.6115H17.5268C16.9682 16.6115 16.5156 16.1605 16.5156 15.6041V9.22342C16.5156 8.66697 16.9682 8.21603 17.5268 8.21603H36.066C36.6246 8.21603 37.0772 8.66697 37.0772 9.22342V15.6041Z",
    fill: "#1A1A1A"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6328 10.2308H34.981",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6328 12.3298H34.981",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3359 14.4287H32.2908",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6909 29.109L64.2188 29.0502",
    stroke: "#1A1A1A",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1983 28.3736C63.8306 27.7823 63.0515 27.5998 62.4581 27.9658C61.8646 28.3321 61.6815 29.1083 62.0488 29.6996C62.4161 30.2908 63.1955 30.4733 63.789 30.1073C64.3828 29.7414 64.566 28.9652 64.1983 28.3736Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M100.233 32.2269C100.233 32.7834 99.7808 33.2343 99.2223 33.2343H80.683C80.1245 33.2343 79.6719 32.7834 79.6719 32.2269V25.8462C79.6719 25.2898 80.1245 24.8389 80.683 24.8389H99.2223C99.7808 24.8389 100.233 25.2898 100.233 25.8462V32.2269Z",
    fill: "#1A1A1A"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7812 26.854H98.1294",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7812 28.9526H98.1294",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4844 31.0516H95.4395",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1095 6.11053L62.0859 18.0891",
    stroke: "#1A1A1A",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6197 17.5926C60.9536 17.384 60.2441 17.7531 60.0351 18.4164C59.8257 19.0801 60.1962 19.787 60.862 19.9953C61.5282 20.2038 62.2377 19.8347 62.4467 19.1714C62.6561 18.508 62.2859 17.8012 61.6197 17.5926Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5278 8.21594C86.5278 8.77239 86.0752 9.22333 85.5167 9.22333H73.7611C73.2026 9.22333 72.75 8.77239 72.75 8.21594V1.83527C72.75 1.27882 73.2026 0.827881 73.7611 0.827881H85.5167C86.0752 0.827881 86.5278 1.27882 86.5278 1.83527V8.21594Z",
    fill: "#1A1A1A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8594 2.84253H84.4242",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8594 4.9415H84.4242",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5625 7.04041H81.7336",
    stroke: "white",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4375 43.981L17.0557 45.1893",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2266 47.5512L100.878 107.779",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "2.93 2.93"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M102.461 108.96L104.079 110.168",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4329 57.5817C22.9725 57.5817 29.0846 51.4924 29.0846 43.9808C29.0846 36.4692 22.9725 30.3799 15.4329 30.3799C7.89331 30.3799 1.78125 36.4692 1.78125 43.9808C1.78125 51.4924 7.89331 57.5817 15.4329 57.5817Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4328 58.7565C7.25491 58.7565 0.601562 52.1282 0.601562 43.9804C0.601562 35.8325 7.25491 29.2046 15.4328 29.2046C23.6108 29.2046 30.2641 35.8332 30.2641 43.9807C30.2641 52.1282 23.6111 58.7565 15.4328 58.7565ZM15.4328 31.5554C8.5558 31.5554 2.96113 37.1293 2.96113 43.9807C2.96113 50.8322 8.5558 56.4064 15.4328 56.4064C22.3099 56.4064 27.9045 50.8322 27.9045 43.9807C27.9045 37.1293 22.3099 31.5554 15.4328 31.5554Z",
    fill: "#F48000"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4034 37.768H9.01567C7.842 37.768 6.89062 38.7158 6.89062 39.8851V47.0834C6.89062 48.2527 7.842 49.2006 9.01567 49.2006H18.7482L22.1909 52.3763V49.2006H22.4034C23.5771 49.2006 24.5285 48.2527 24.5285 47.0834V39.8851C24.5285 38.7158 23.5771 37.768 22.4034 37.768Z",
    fill: "#FFE4C6"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 39.9993L18.4601 43.1667L12.9531 46.334V39.9993Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.445046,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2422 88.6451L29.1855 89.2033",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9297 90.2776L105.849 111.225",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeMiterlimit: 10,
    strokeDasharray: "2.88 2.88"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M107.703 111.762L109.646 112.32",
    stroke: "#F48000",
    strokeWidth: 0.749132,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1378 101.488C48.4436 94.2089 48.4436 82.408 41.1378 75.1294C33.8321 67.8508 21.9871 67.8508 14.6814 75.1294C7.37561 82.408 7.37561 94.2089 14.6814 101.488C21.9871 108.766 33.8321 108.766 41.1378 101.488Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4454_121031",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 70,
    width: 38,
    height: 38
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4894 101.823C47.7951 94.5445 47.7951 82.7436 40.4894 75.465C33.1836 68.1864 21.3387 68.1864 14.0329 75.465C6.72717 82.7436 6.72717 94.5445 14.0329 101.823C21.3387 109.102 33.1836 109.102 40.4894 101.823Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4454_121031)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8082 93.4437H30.2089V86.9623H24.2941V93.4437H21.6947C18.7008 93.4437 16.2734 95.8617 16.2734 98.8448V102.265H38.2296V98.8448C38.2296 95.8617 35.8025 93.4437 32.8082 93.4437Z",
    fill: "#FFE4C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2894 92.4284C25.2044 92.7916 26.2016 92.9935 27.2467 92.9935C28.2917 92.9935 29.2889 92.7916 30.2039 92.4284V86.9621H24.2891V92.4284H24.2894Z",
    fill: "#FFD2A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8086 93.4438H31.5842C31.5849 93.4741 31.5888 93.5033 31.5888 93.5336C31.5888 96.0195 29.5662 98.0346 27.071 98.0346C24.5758 98.0346 22.5532 96.0195 22.5532 93.5336C22.5532 93.5033 22.557 93.4737 22.5577 93.4438H21.6947C18.7008 93.4438 16.2734 95.8618 16.2734 98.8449V111.089H38.2295V98.8449C38.2299 95.8618 35.8029 93.4438 32.8086 93.4438Z",
    fill: "#FAA64B",
    stroke: "#FAA64B",
    strokeWidth: 0.249711,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2384 91.2831C31.6545 91.2831 35.2345 87.7164 35.2345 83.3167C35.2345 78.9169 31.6545 75.3502 27.2384 75.3502C22.8222 75.3502 19.2422 78.9169 19.2422 83.3167C19.2422 87.7164 22.8222 91.2831 27.2384 91.2831Z",
    fill: "#FFF1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3177 83.3167C36.3177 78.3201 32.2521 74.2697 27.237 74.2697C22.2218 74.2697 18.1562 78.3201 18.1562 83.3167",
    stroke: "#F48000",
    strokeWidth: 0.803248,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9531 83.3166C14.9531 85.5741 16.5944 87.4047 18.6188 87.4047C20.6436 87.4047 20.2175 85.5745 20.2175 83.3166C20.2175 81.0588 20.6436 79.2289 18.6188 79.2289C16.5944 79.2286 14.9531 81.0588 14.9531 83.3166Z",
    fill: "#F48000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7783 83.3166C39.7783 85.5741 38.137 87.4047 36.1126 87.4047C34.0882 87.4047 34.5139 85.5745 34.5139 83.3166C34.5139 81.0588 34.0879 79.2289 36.1126 79.2289C38.137 79.2286 39.7783 81.0588 39.7783 83.3166Z",
    fill: "#F48000"
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M40.466 101.823C47.7717 94.5446 47.7717 82.7437 40.466 75.4651C33.1602 68.1865 21.3152 68.1865 14.0095 75.4651C6.70373 82.7437 6.70373 94.5446 14.0095 101.823C21.3152 109.102 33.1602 109.102 40.466 101.823Z",
    stroke: "#F48000",
    strokeWidth: 1.748,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M143.878 111.031C143.878 112.032 143.064 112.843 142.059 112.843H75.8654C74.8609 112.843 74.0469 112.032 74.0469 111.031V71.988C74.0469 70.9872 74.8612 70.1762 75.8654 70.1762H142.059C143.064 70.1762 143.878 70.9875 143.878 71.988V111.031Z",
    fill: "#FFF1E1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M142.062 113.889H75.8685C74.2869 113.889 73 112.607 73 111.031V71.988C73 70.4124 74.2866 69.1302 75.8685 69.1302H142.062C143.644 69.1302 144.93 70.4124 144.93 71.988V111.031C144.93 112.607 143.643 113.889 142.062 113.889ZM77.0862 71.9685C76.6779 71.9685 76.3455 72.2997 76.3455 72.7064V110.313C76.3455 110.72 76.6779 111.051 77.0862 111.051H140.844C141.252 111.051 141.585 110.72 141.585 110.313V72.7064C141.585 72.2997 141.252 71.9685 140.844 71.9685H77.0862Z",
    fill: "#1A1A1A"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7175 110.247C58.6231 110.535 58.5703 110.842 58.5703 111.162V113.065C58.5703 114.694 59.896 116.015 61.531 116.015H156.395C158.031 116.015 159.356 114.694 159.356 113.065V111.162C159.356 110.842 159.303 110.535 159.209 110.247H58.7175Z",
    fill: "#1A1A1A"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2422 110.247V112.209C97.2422 113.283 98.1163 114.154 99.1949 114.154H118.721C119.799 114.154 120.674 113.283 120.674 112.209V110.247H97.2422Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4454_121031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 231,
    height: 117,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIntegrationDt);
export default __webpack_public_path__ + "static/media/laptop_integration_DT.4429354f073122beb759f454c34874fd.svg";
export { ForwardRef as ReactComponent };